import { IFilterElement } from "@saleor/components/Filter";
import { maybe, parseBoolean } from "@saleor/misc";
import {
  RotaryFilterKeys,
  RotaryListFilterOpts
} from "@saleor/rotary/components/RotaryListPage/filters";
import {
  RotaryListUrlFilters,
  RotaryListUrlFiltersEnum,
  RotaryListUrlQueryParams
} from "@saleor/rotary/urls";
import { RotaryFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "rotaryFilters";
export function getFilterOpts(
  params: RotaryListUrlFilters
): RotaryListFilterOpts {
  return {
    isEnable: {
      active: params.isEnable !== undefined,
      value: maybe(() => parseBoolean(params.isEnable, true))
    }
  };
}

export function getFilterVariables(
  params: RotaryListUrlFilters
): RotaryFilterInput {
  return {
    isEnable:
      params.isEnable !== undefined
        ? parseBoolean(params.isEnable, false)
        : undefined,
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<RotaryListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  RotaryListUrlQueryParams,
  RotaryListUrlFilters
>(RotaryListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<RotaryFilterKeys>
): RotaryListUrlFilters {
  const { name } = filter;

  switch (name) {
    case RotaryFilterKeys.isEnable:
      return getSingleValueQueryParam(
        filter,
        RotaryListUrlFiltersEnum.isEnable
      );
  }
}
